import Oidc from 'oidc-client';
import { monitore } from '../components/helpers/helpers';
import store from '../store';

/**
 * Config for the oidc client.
 */
const settings = {
  userStore: new Oidc.WebStorageStateStore(),
  authority: process.env.VUE_APP_HELLOID_AUTHORITY,
  client_id: process.env.VUE_APP_HELLOID_CLIENT_ID,
  client_secret: process.env.VUE_APP_HELLOID_CLIENT_SE,
  redirect_uri: window.location.origin + '/callback',
  response_type: 'code',
  response_mode: 'query',
  scope: 'openid',
  post_logout_redirect_uri: window.location.origin,
  popup_post_logout_redirect_uri: window.location.origin,
  silent_redirect_uri: window.location.origin + '/silent-renew',
  automaticSilentRenew: true,
  silentRequestTimeout: 10000, //en ms
  filterProtocolClaims: true,
  loadUserInfo: false,
  revokeAccessTokenOnSignout: true,
  metadataSeed: {
    end_session_endpoint: process.env.VUE_APP_HELLOID_SIGN_OFF,
  },
};

Oidc.Log.logger = console;
Oidc.Log.level = Oidc.Log.DEBUG;

var mgr = new Oidc.UserManager(settings);

// console.log("mgr: ", mgr)

//console.log("New User Loaded：", arguments);
mgr.events.addUserLoaded(async function (user) {
  console.log('>>>>>>>>>>New User Loaded：', user);
  if (['true', 'TRUE', 'True'].indexOf(user.profile.isCotisant) < 0 && user.profile.source != 'AzureAD') {
    const userNonCotisant = { ...user };
    delete userNonCotisant.access_token;
    store.commit('setLoggedUser', userNonCotisant);
  } else {
    //reafectation du state d'avant login
    store.commit('setState', user.state);
    // set user in store
    store.commit('setLoggedUser', user);
    //user.access_token
    console.log('>>>> Acess_token: ok ');
    // Get profile in mongoDB
    await store.dispatch('getProfile');
  }
});

mgr.events.addAccessTokenExpiring(function () {
  window.localStorage.clear();
  store.commit('resetUser');
  store.commit('resetState');
  console.log('AccessToken Expiring：', arguments);
});

mgr.events.addAccessTokenExpired(function () {
  window.localStorage.clear();
  store.commit('resetUser');
  store.commit('resetState');
  console.log('AccessToken Expired：', arguments);
  alert('Session expired. Going out!');
  mgr
    .signoutRedirect()
    .then(function (resp) {
      store.commit('resetUser');
      console.log('>>>>>>>>>>signed out', resp);
    })
    .catch(function (err) {
      console.log(err);
    });
});

mgr.events.addSilentRenewError(function () {
  console.error('Silent Renew Error：', arguments);
});

mgr.events.addUserSignedOut(function () {
  alert('Going out!');
  console.log('UserSignedOut：', arguments);
  mgr
    .signoutRedirect()
    .then(function (resp) {
      console.log('signed out', resp);
    })
    .catch(function (err) {
      console.log(err);
    });
});

export default class SecurityService {
  // Redirect of the current window to the authorization endpoint.
  signIn() {
    //mgr.signinRedirect({state:store.getters.url}).catch(function(err) {
    window.localStorage.clear();
    monitore('Sign In');
    mgr.signinRedirect({ state: store.state }).catch(function (err) {
      console.log(err);
    });
  }

  // Redirect of the current window to the end session endpoint
  signOut() {
    mgr
      .signoutRedirect()
      .then(function (resp) {
        console.log('signed out', resp);
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  // Sign in silent after comming from HelloID
  renewToken() {
    return new Promise((resolve, reject) => {
      mgr
        .signinSilent({ state: store.state })
        .then((user) => {
          return resolve(user);
        })
        .catch(function (err) {
          return reject(err);
        });
    });
  }

  // Get the user who is logged in
  getUser() {
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          return resolve(user);
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the user who is logged in
  removeUser() {
    mgr
      .createSignoutRequest()
      .then(function (resp) {
        store.commit('resetUser');
        console.log('>>>>>>>>>>signed out', resp);
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  // Get the profile of the user logged in
  getProfile() {
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          console.log('user in auth service', user);
          if (user == null) {
            return resolve(null);
          } else {
            return resolve(user.profile);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the token id
  getIdToken() {
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            return resolve(null);
          } else {
            return resolve(user.id_token);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the session state
  getSessionState() {
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            return resolve(null);
          } else {
            return resolve(user.session_state);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the access token of the logged in user
  getAccessToken() {
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            return resolve(null);
          } else {
            return resolve(user.access_token);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Takes the scopes of the logged in user
  getScopes() {
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            return resolve(null);
          } else {
            return resolve(user.scopes);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the user roles logged in
  getRole() {
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            return resolve(null);
          } else {
            return resolve(user.profile.role);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  getUserManager() {
    return mgr;
  }
  // Get the user who is logged in
  isAuthenticated() {
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            return resolve(false);
          } else {
            return resolve(true);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }
}
